import React from "react";
import styles from "./PackingInstructionsApp.module.scss";
import ShopStylingWrapper from "../ShopStylingWrapper";

function PackingInstructionsApp(props) {
    const { Page, sharedAppProps } = props;

    return (
        <ShopStylingWrapper {...props} appProps={sharedAppProps}>
            <div className={styles["app-container"]}>
                <Page {...props} appProps={sharedAppProps} />
            </div>
        </ShopStylingWrapper>
    );
}

export default PackingInstructionsApp;
